export default class Attachment {
  data = null;

  constructor (data) {
    this.data = data;
  }

  get type () {
    return this.data.type;
  }

  get comment () {
    return this.data.comment;
  }

  get id () {
    return this.data.id;
  }

  get mime () {
    return this.data.mime;
  }

  get createdBy () {
    return this.data.name;
  }

  get name () {
    return this.data.fileName;
  }

  get extension () {
    return this.name.split('.').pop();
  }

  get fullName () {
    return `${this.type} | ${this.name}`;
  }
};
